// src/components/session-timeout.component.tsx
import React, { Component } from "react";
import {
  Button,
  HeadingText,
  Modal,
  Box,
  UtilityText
} from "@leagueplatform/genesis-core";
import { FormattedMessage } from "react-intl";
var SESSION_TIMEOUT_BUFFER = 15e4;
var sessionTimeoutActions = {
  start: () => {
  }
};
var registerSessionTimeout = (ref) => {
  if (ref)
    sessionTimeoutActions.start = ref.startTimeout;
};
var SessionTimeout = class extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.startTimeout = (timeoutInterval) => {
      const { getIsAuthenticated } = this.props;
      const { idleTimeout } = this.state;
      const timeoutBeforePrompt = timeoutInterval - SESSION_TIMEOUT_BUFFER;
      if (timeoutBeforePrompt > 0) {
        if (idleTimeout)
          this.stopTimeout();
        this.setState({
          idleTimeout: setTimeout(() => {
            getIsAuthenticated().then((isAuthenticated) => {
              if (isAuthenticated)
                this.setState({ showModal: true });
            });
          }, timeoutBeforePrompt)
        });
      }
    };
    this.stopTimeout = () => {
      const { idleTimeout } = this.state;
      clearTimeout(idleTimeout);
    };
    this.state = {
      idleTimeout: null,
      showModal: false
    };
    registerSessionTimeout(this);
  }
  render() {
    const { onSessionExpire, onSessionExtend } = this.props;
    const { showModal } = this.state;
    return /* @__PURE__ */ React.createElement(Modal.Root, { open: showModal }, /* @__PURE__ */ React.createElement(Modal.Content, { showCloseButton: false }, /* @__PURE__ */ React.createElement(Modal.Title, null, /* @__PURE__ */ React.createElement(HeadingText, { css: { textAlign: "center" }, level: "1", size: "lg" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "SESSION_TIMEOUT" }))), /* @__PURE__ */ React.createElement(
      UtilityText,
      {
        css: {
          marginTop: "$oneAndHalf",
          marginBottom: "$oneAndHalf",
          display: "block"
        }
      },
      /* @__PURE__ */ React.createElement(FormattedMessage, { id: "SESSION_ABOUT_TO_TIMEOUT" })
    ), /* @__PURE__ */ React.createElement(Box, { css: { display: "flex", justifyContent: "end" } }, /* @__PURE__ */ React.createElement(
      Button,
      {
        priority: "secondary",
        onClick: () => {
          onSessionExpire();
          this.setState({ showModal: false });
        }
      },
      /* @__PURE__ */ React.createElement(FormattedMessage, { id: "SESSION_LOG_OUT" })
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        css: { marginLeft: "$one" },
        onClick: () => {
          onSessionExtend();
          this.setState({ showModal: false });
        }
      },
      /* @__PURE__ */ React.createElement(FormattedMessage, { id: "CONTINUE_SESSION" })
    ))));
  }
};
export {
  SessionTimeout,
  sessionTimeoutActions
};
//# sourceMappingURL=index.js.map